import React from "react";
import manone from "../../../../assets/pics/infinitbanner/manone.png"
import mantwo from "../../../../assets/pics/infinitbanner/mantwo.png"
import manthree from "../../../../assets/pics/infinitbanner/manthree.png"
// import manfive from "../../../../assets/pics/infinitbanner/manfive.jpg"
import mansix from "../../../../assets/pics/infinitbanner/mansix.png"
// import ladyonetwo from "../../../../assets/pics/infinitbanner/ladyonetwo.webp"
// import nadya from "../../../../assets/pics/infinitbanner/nadya.jpg"
// import umklthum from "../../../../assets/pics/infinitbanner/umklthum.jpg"
import ladyfive from "../../../../assets/pics/infinitbanner/ladyfive.png"
import ladysix from "../../../../assets/pics/infinitbanner/ladysix.jpg"
import ahmedmazhar from "../../../../assets/pics/infinitbanner/new/ahmedmazhar.jpg"
import umklthom from "../../../../assets/pics/infinitbanner/new/umklthom.png"
import shadya from "../../../../assets/pics/infinitbanner/new/shadya.jpg"
import nadyalotfee from "../../../../assets/pics/infinitbanner/new/nadyalotfee.png"


import Img from "../../../molecules/Img";
import Slider from "react-slick";
import { useNavigate } from "react-router-dom";

const InfiniteScrollBanner = ({data}) => {
  // console.log("InfiniteScrollBanner", data);

 
  const images=[
    {src: manone , alt: "Banner pic 1"},
    {src: mantwo , alt: "Banner pic 2"},
    {src: manthree , alt: "Banner pic 3"},
    {src: ahmedmazhar , alt: "Banner pic 5"},
    {src: mansix , alt: "Banner pic 6"},
    // {src: ladyonetwo , alt: "Banner pic 3"},
    {src: ladysix , alt: "Banner pic ladysix"},
    {src: ladyfive , alt: "Banner pic ladyfive"},
    {src: umklthom , alt: "Banner pic umklthum"},
    {src: nadyalotfee , alt: "Banner pic nadya"},
    {src: shadya , alt: "Banner pic shadya"},
    
  ]

  const settings = {
    // dots: true,
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    speed: 4000,
    autoplaySpeed: 1,
    cssEase: "linear",
    variableWidth: true, // Allow custom widths for slides
    responsive: [
      {
        breakpoint: 768, // Mobile screens (below 768px width)
        settings: {
          slidesToShow: 2, // Show only 1 slide
          variableWidth: false, // Fix width for better layout
        },
      },
    ],
  };
  const navigate = useNavigate()


  const handleOnClick=(id) => {
    // console.log("onClick",id)
    navigate(`about.aspx?id=${id}`)

  }
  return (
    <div className="relative overflow-hidden h-full">
      {/* <div className="whitespace-nowrap animate-scroll">
      {Array.from({length:3}).map((_,repeatedIndex)=>(
        images.map((image, index)=>(
          <Img
            key={`${repeatedIndex}-${index}`}
            src={image.src}
            alt={image.alt}
            rectangular
          />
        ))
      ))}

        
      </div> */}

      <div className="slider-container">
          <Slider {...settings}>
                    {data.map((image, index)=>
                    <div key={index} className="slick-slide !w-[160px] mx-[0px] cursor-pointer">
                        <Img
                          src={image.characterPhotoe}
                          alt={image.characterPhotoe}
                          rectangular
                          onClick={()=>handleOnClick(image.characterId)}
                        />
                    </div>
                    )}    
          </Slider>
        </div>
        
    </div>
  );
};

export default InfiniteScrollBanner;
